"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUFFER_TEXT_ENCODING = 'utf8';
exports.HEX_PREFIX = '0x';
exports.ZERO_ADDRESS = "0x".concat('0'.repeat(40));